module.exports = __webpack_public_path__ + "assets/img/vue-website-icon2.ed84445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/vue-website-icon2.png
// module id = 52
// module chunks = 0